import React, { useState } from 'react';
import './saving.css';
import costimage from './cost-image.jpg.png';
import energyimage from './energy-image.png';


function ChillerSavingsCalculator() {
  const [step, setStep] = useState(1);
  // Store each chiller's result (savings, kWh, calculation strings)
  const [chillerResults, setChillerResults] = useState([]);


  const [chillerType, setChillerType] = useState("");
  const [otherChillerBrand, setOtherChillerBrand] = useState("");
  const [chillerRT, setChillerRT] = useState("");
  const [chillerYear, setChillerYear] = useState("");
  const [operatingUnit, setOperatingUnit] = useState("");
  const [buildingType, setBuildingType] = useState("");
  const [operatingDays, setOperatingDays] = useState("");

  const [chillerDesignCapacity, setChillerDesignCapacity] = useState("");
  const [numberOfChillers, setNumberOfChillers] = useState("");
  const [fla, setFla] = useState("");
  const [tariff, setTariff] = useState(""); 
  const [tariffUsed, setTariffUsed] = useState("");
  const [peakHourTariff, setPeakHourTariff] = useState(0);
  const [offPeakTariff, setOffPeakTariff] = useState(0);

  const [peakHours, setPeakHours] = useState(""); 
  const [offpeakHours, setOffpeakHours] = useState(""); 

  const [estiSavings, setestiSavings] = useState(null);
  const [savedKwh, setSavedKwh] = useState(null);

  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({ 
    name: '', 
    email: '', 
    company: '', 
    consent: false, 
    location: '' 
  });
  const preventMinusAndE = (e) => {
    if (e.key === "-" || e.key.toLowerCase() === "e") {
      e.preventDefault();
    }
  };
  

  // The multi-chiller array
  const [chillers, setChillers] = useState([
    {
      chillerType: "",
      otherChillerBrand: "",
      chillerRT: "",
      chillerYear: "",
      operatingUnit: "",
      operatingDays: "",
      chillerDesignCapacity: "",
      numberOfChillers: "",
      fla: "",
      peakHours: "",
      offpeakHours: ""
    }
  ]);

  // Validation for Step 3
  function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); 
  }

  const step3IsValid =
    formData.name &&
    validateEmail(formData.email) &&
    formData.company &&
    formData.consent &&
    formData.location;

  // Tariff definitions
  const tariffOptions = {
    B: { cost: [{ range: "1-200kwh", rate: 0.435 }, { range: "201kwh>", rate: 0.509 }], minCharge: 7.20 },
    C1: { cost: [{ range: "all", rate: 0.365 }], minCharge: 600 },
    C2: { cost: [{ type: "peak", rate: 0.365 }, { type: "off-peak", rate: 0.224 }], minCharge: 600 },
    D: { cost: [{ range: "1-200kwh", rate: 0.38 }, { range: "201kwh>", rate: 0.441 }] },
    E1: { cost: [{ type: "demand", rate: 29.6 }, { type: "energy", rate: 0.337 }], minCharge: 600 },
    E2: { cost: [{ type: "demand", rate: 37.0 }, { type: "peak", rate: 0.355 }, { type: "off-peak", rate: 0.219 }], minCharge: 600 },
    E3: { cost: [{ type: "demand", rate: 35.5 }, { type: "peak", rate: 0.337 }, { type: "off-peak", rate: 0.202 }], minCharge: 600 }
  };

  const validateCurrentStep = () => {
    switch (step) {
      case 1:
        // Step 1: Ensure buildingType and tariff are chosen
        if (!buildingType || !tariff) {
          return false;
        }
        // Important: return true here so we don't fall through to case 2
        return true;
  
      case 2:
        // Step 2: Check if all chiller fields are filled
        return isStep2Complete();
  
      default:
        return true;
    }
  };
  
  function isStep2Complete() {
    // We must check each chiller in the array
    for (const chiller of chillers) {
      // If chillerType is empty and no other brand is provided
      if (!chiller.chillerType && !chiller.otherChillerBrand) {
        return false;
      }
  
      // If any numeric fields are empty strings
      if (
        chiller.chillerRT === "" ||
        chiller.chillerYear === "" ||
        chiller.chillerDesignCapacity === "" ||
        chiller.operatingDays === "" ||
        chiller.operatingUnit === "" ||
        chiller.fla === "" ||
        chiller.numberOfChillers === "" ||
        chiller.peakHours === "" ||
        chiller.offpeakHours === ""
      ) {
        return false;
      }
    }
    return true;
  }
  
  

  // 2) Summation for multiple chillers
  const calculateAllChillers = () => {
    let totalSavings = 0;
    let totalKwh = 0;
    let newChillerResults = []; // array to hold individual chiller results
  
    chillers.forEach((chiller, i) => {
      const flaDecimal = chiller.fla === "" ? 0 : Number(chiller.fla);
      const designCapacity = Number(chiller.chillerDesignCapacity) || 0;
      const rt = Number(chiller.chillerRT) || 0;
      const peakH = Number(chiller.peakHours) || 0;
      const offpeakH = Number(chiller.offpeakHours) || 0;
      const opDays = Number(chiller.operatingDays) || 0;
      const opUnit = Number(chiller.operatingUnit) || 0;
  
      // Energy cost
      const chillerSavings =
        ((designCapacity * rt * flaDecimal * peakH * peakHourTariff * opDays) +
         (designCapacity * rt * flaDecimal * offpeakH * offPeakTariff * opDays))
        * 0.12 * opUnit * 12;
  
      // Energy kWh
      const chillerKwh =
        ((designCapacity * rt * flaDecimal * peakH * opDays) +
         (designCapacity * rt * flaDecimal * offpeakH * opDays))
        * 0.12 * opUnit * 12;
  
      // Build a calculation "process" string for each chiller
      const calcProcessKwh = `(${designCapacity} * ${rt} * ${flaDecimal} * ${peakH} * ${opDays} + ${designCapacity} * ${rt} * ${flaDecimal} * ${offpeakH} * ${opDays}) * 0.12 * ${opUnit} * 12`;
      const calcProcessCost = `(${designCapacity} * ${rt} * ${flaDecimal} * ${peakH} * ${peakHourTariff} * ${opDays} + ${designCapacity} * ${rt} * ${flaDecimal} * ${offpeakH} * ${offPeakTariff} * ${opDays}) * 0.12 * ${opUnit} * 12`;
  
      totalSavings += chillerSavings;
      totalKwh += chillerKwh;
  
      // Save results for this chiller
      newChillerResults.push({
        chillerIndex: i + 1,
        chillerSavings,
        chillerKwh,
        calcProcessKwh,
        calcProcessCost
      });
    });
  
    // Store the total
    setestiSavings(totalSavings);
    setSavedKwh(totalKwh);
  
    // Store the array of each chiller's results
    setChillerResults(newChillerResults);
  };
  

  // 3) Set Tariff & Tariff Rates
  const updateTariffRates = (selectedTariff) => {
    if (!tariffOptions[selectedTariff]) {
      alert("Please select a valid tariff!");
      return;
    }

    const tariffDetails = tariffOptions[selectedTariff];
    let peakTariff = 0;
    let offTariff = 0;
    let used = "";

    if (selectedTariff === "B") {
      peakTariff = tariffDetails.cost[0]?.rate || 0.435;
      offTariff = tariffDetails.cost[1]?.rate || 0.509;
      used = `Tariff B (1-200kWh: ${peakTariff}, 201+ kWh: ${offTariff})`;
    } else if (selectedTariff === "D") {
      peakTariff = tariffDetails.cost[0]?.rate || 0.38;
      offTariff = tariffDetails.cost[1]?.rate || 0.441;
      used = `Tariff D (1-200kWh: ${peakTariff}, 201+ kWh: ${offTariff})`;
    } else if (selectedTariff === "C1") {
      peakTariff = offTariff = tariffDetails.cost[0]?.rate || 0.365;
      used = `Tariff C1 (${peakTariff} for both peak and off-peak)`;
    } else if (selectedTariff === "C2") {
      peakTariff = tariffDetails.cost.find(c => c.type === "peak")?.rate || 0.365;
      offTariff = tariffDetails.cost.find(c => c.type === "off-peak")?.rate || 0.224;
      used = `Tariff C2 (Peak: ${peakTariff}, Off-Peak: ${offTariff})`;
    } else if (selectedTariff === "E1") {
      peakTariff = offTariff = tariffDetails.cost.find(c => c.type === "energy")?.rate || 0.337;
      used = `Tariff E1 (Energy Rate: ${peakTariff})`;
    } else if (selectedTariff === "E2") {
      peakTariff = tariffDetails.cost.find(c => c.type === "peak")?.rate || 0.355;
      offTariff = tariffDetails.cost.find(c => c.type === "off-peak")?.rate || 0.219;
      used = `Tariff E2 (Peak: ${peakTariff}, Off-Peak: ${offTariff})`;
    } else if (selectedTariff === "E3") {
      peakTariff = tariffDetails.cost.find(c => c.type === "peak")?.rate || 0.337;
      offTariff = tariffDetails.cost.find(c => c.type === "off-peak")?.rate || 0.202;
      used = `Tariff E3 (Peak: ${peakTariff}, Off-Peak: ${offTariff})`;
    }

    setTariffUsed(used);
    setPeakHourTariff(peakTariff);
    setOffPeakTariff(offTariff);
  };

  // 4) Add & Remove Chillers
  const addChiller = () => {
    setChillers((prev) => [
      ...prev,
      {
        chillerType: "",
        otherChillerBrand: "",
        chillerRT: "",
        chillerYear: "",
        operatingUnit: "",
        operatingDays: "",
        chillerDesignCapacity: "",
        numberOfChillers: "",
        fla: "",
        peakHours: "",
        offpeakHours: ""
      }
    ]);
  };

  const removeChiller = (index) => {
    setChillers((prev) => {
      // If there's only one chiller, do not remove it
      if (prev.length === 1) {
        // Optionally alert or show a message
        alert("Cannot remove the only chiller!");
        return prev; // Return unchanged
      }
  
      // Otherwise, remove the selected chiller
      return prev.filter((_, i) => i !== index);
    });
  };
  

  const handleChillerChange = (index, field, value) => {
    const updated = [...chillers];
    updated[index][field] = value;
    setChillers(updated);
  };

  // 5) Step Navigation
  const nextStep = () => {
    if (validateCurrentStep()) {
      setStep((prev) => prev + 1);
    } else {
      alert("Please fill in all required fields for this step.");
    }
  };

  const prevStep = () => {
    if (step > 1) {
      setStep((prev) => prev - 1);
    }
  };

  // 6) Send Email
  const sendEmail = () => {
    // IMPORTANT: include the entire "chillers" array so the backend can loop over it
    const data = {
      buildingType,
      tariff,
      tariffUsed,
      peakHourTariff,
      offPeakTariff,
      chillerType,
      otherChillerBrand,
      chillerDesignCapacity,
      chillerRT,
      chillerYear,
      operatingDays,
      numberOfChillers,
      operatingUnit,
      peakHours,
      offpeakHours,
      fla,
      // Customer details
      customerInfo: formData,
      // Summaries
      results: {
        estiSavings,
        savedKwh
      },
      // The entire array of chiller inputs
      chillers,
      // The detailed results array for each chiller's cost/kWh
      chillerResults
    };

    console.log("Data being sent:", data); // debug

    fetch('SendEmailSavings.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(result => {
        console.log('Email sent successfully:', result);
      })
      .catch(error => {
        console.error('Error sending email:', error);
      });
  };

  const submitCalculator = () => {
    if (!step3IsValid) {
      setErrors({ step3: true });
    } else {
      setErrors({});
      sendEmail();
      setStep(4);
    }
  };

  return (
    <div className="sv-container">
      <div className="sv-progress-bar">
        <div className="sv-progress" style={{ width: `${(step / 4) * 100}%` }}></div>
      </div>

      {step === 1 && (
  <div className="sv-form-step sv-step-1-horizontal">
    {/* Horizontal row containing property type */}
    <div className="sv-horizontal-row">
      {/* Property Type */}
      <div className="sv-input-group-horizontal">
        <label>Please Select Property Type:</label>
        <div className="sv-property-type-options">
          <button
            className={`sv-property-btn ${buildingType === 'Commercial' ? 'active' : ''}`}
            onClick={() => setBuildingType('Commercial')}
          >
            Commercial
          </button>
          <button
            className={`sv-property-btn ${buildingType === 'Industrial' ? 'active' : ''}`}
            onClick={() => setBuildingType('Industrial')}
          >
            Industrial
          </button>
        </div>
      </div>
    </div>

    {/* Conditionally render the Electricity Tariff section 
        only if buildingType is chosen */}
    {buildingType && (
      <div className="sv-horizontal-row">
        <div className="sv-input-group-horizontal">
          <label>Electricity Tariff:</label>
          {buildingType === "Commercial" && (
            <div className="sv-tariff-buttons">
              {["B", "C1", "C2"].map((tariffKey) => (
                <button
                  key={tariffKey}
                  className={`sv-tariff-btn ${tariff === tariffKey ? "active" : ""}`}
                  onClick={() => {
                    setTariff(tariffKey);
                    updateTariffRates(tariffKey);
                  }}
                >
                  {tariffKey}
                </button>
              ))}
            </div>
          )}
          {buildingType === "Industrial" && (
            <div className="sv-tariff-buttons">
              {["D", "E1", "E2", "E3"].map((tariffKey) => (
                <button
                  key={tariffKey}
                  className={`sv-tariff-btn ${tariff === tariffKey ? "active" : ""}`}
                  onClick={() => {
                    setTariff(tariffKey);
                    updateTariffRates(tariffKey);
                  }}
                >
                  {tariffKey}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    )}

    {/* Next Button */}
    <div className="sv-navigation-buttons-horizontal">
      <button onClick={nextStep} className="sv-next-btn">Next</button>
    </div>
  </div>
)}



{step === 2 && (
  <div className="sv-form-step sv-step-horizontal">
    {chillers.map((chiller, index) => (
      <div key={index} className="sv-chiller-row-container">
        {/* Chiller Number Label */}
        <div className="sv-chiller-row-header">
          <h3>Chiller {index + 1}</h3>
        </div>

        {/* The two-column layout for the chiller fields */}
        <div className="sv-chiller-row">
          {/* Left Column */}
          <div className="sv-chiller-left-col">
            {chiller.chillerType !== "otherBrand" ? (
              <select
                value={chiller.chillerType}
                onChange={(e) => handleChillerChange(index, "chillerType", e.target.value)}
                className="sc-dropdown-2"
              >
                <option value="">Select Chiller Brand</option>
                <option value="carrier">Carrier</option>
                <option value="daikin">Daikin</option>
                <option value="dunhambush">Dunham Bush</option>
                <option value="hitachi">Hitachi</option>
                <option value="trane">Trane</option>
                <option value="york">York</option>
                <option value="otherBrand">Other Brand</option>
              </select>
            ) : (
              <input
                type="text"
                placeholder="Specify Brand"
                value={chiller.otherChillerBrand}
                onChange={(e) => handleChillerChange(index, "otherChillerBrand", e.target.value)}
                className="sc-dropdown-2"
              />
            )}

            <input
              type="number"
              placeholder="Number of Chillers"
              onKeyDown={preventMinusAndE}
              value={chiller.numberOfChillers}
              onChange={(e) => handleChillerChange(index, "numberOfChillers", e.target.value)}
            />

            <input
              type="number"
              placeholder="Chiller in operating"
              onKeyDown={preventMinusAndE}
              value={chiller.operatingUnit}
              onChange={(e) => handleChillerChange(index, "operatingUnit", e.target.value)}
            />

            <input
              type="number"
              placeholder="Chiller RT"
              onKeyDown={preventMinusAndE}
              value={chiller.chillerRT}
              onChange={(e) => handleChillerChange(index, "chillerRT", e.target.value)}
            />

            <input
              type="number"
              placeholder="Chiller Efficiency (kW/RT)"
              onKeyDown={preventMinusAndE}
              value={chiller.chillerDesignCapacity}
              onChange={(e) => handleChillerChange(index, "chillerDesignCapacity", e.target.value)}
            />
          </div>

          {/* Right Column */}
          <div className="sv-chiller-right-col">
            <input
              type="number"
              placeholder="Chiller Age (Years)"
              onKeyDown={preventMinusAndE}
              value={chiller.chillerYear}
              onChange={(e) => handleChillerChange(index, "chillerYear", e.target.value)}
            />

            <input
              type="number"
              placeholder="Operating FLA (from 50-100%)"
              onKeyDown={preventMinusAndE}
              value={
                chiller.fla === ""
                  ? ""
                  : parseFloat((chiller.fla * 100).toFixed(2)) // Round for display
              }
              onChange={(e) => {
                if (e.target.value === "") {
                  handleChillerChange(index, "fla", "");
                } else {
                  const val = parseFloat(e.target.value) / 100;
                  handleChillerChange(index, "fla", val);
                }
              }}
            />

            <input
              type="number"
              placeholder="Peak Period Hours"
              onKeyDown={preventMinusAndE}
              value={chiller.peakHours}
              onChange={(e) => handleChillerChange(index, "peakHours", e.target.value)}
            />

            <input
              type="number"
              placeholder="Off-Peak Period Hours"
              onKeyDown={preventMinusAndE}
              value={chiller.offpeakHours}
              onChange={(e) => handleChillerChange(index, "offpeakHours", e.target.value)}
            />

            <input
              type="number"
              placeholder="Monthly Operating Days"
              onKeyDown={preventMinusAndE}
              value={chiller.operatingDays}
              onChange={(e) => handleChillerChange(index, "operatingDays", e.target.value)}
            />
          </div>
        </div>

        {/* Show Add Chiller Button only on the last row */}
        {index === chillers.length - 1 && (
          <div className="sv-add-chiller-container">
            <button onClick={addChiller} className="sv-add-btn">
              Add Chiller
            </button>
          </div>
        )}

        {/* Remove Button (only show if more than 1 chiller) */}
        {chillers.length > 1 && (
          <button
            onClick={() => removeChiller(index)}
            className="sv-remove-btn-outside"
          >
            Remove Chiller
          </button>
        )}
      </div>
    ))}

    {/* Navigation Buttons */}
    <div className="sv-navigation-buttons-horizontal">
      <button onClick={prevStep} className="sv-prev-btn">Previous</button>
      <button
        disabled={!isStep2Complete()}
        onClick={() => {
          calculateAllChillers(); // Summation of all chillers
          setStep(3);
        }}
        className="sv-calculate-btn"
      >
        Next
      </button>
    </div>
  </div>
)}


      {/* STEP 3 */}
      {step === 3 && (
        <div className="sc-step-container">
          <select
            value={formData.location}
            onChange={(e) => setFormData({ ...formData, location: e.target.value })}
            className="sc-dropdown"
          >
            <option value="" disabled hidden>Select Country</option>
            <option value="Malaysia">Malaysia</option>
            <option value="Singapore">Singapore</option>
            <option value="Thailand">Thailand</option>
            <option value="Brunei">Brunei</option>
            <option value="Philippines">Philippines</option>
            <option value="Vietnam">Vietnam</option>
            <option value="Indonesia">Indonesia</option>
            <option value="Burma (Myanmar)">Burma (Myanmar)</option>
            <option value="Cambodia">Cambodia</option>
            <option value="Timor-Leste">Timor-Leste</option>
            <option value="Laos">Laos</option>
          </select>

          <input
            type="text"
            placeholder="Name *"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          />
          <input
            type="email"
            placeholder="Email *"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          />
          <input
            type="text"
            placeholder="Building/Company Name *"
            value={formData.company}
            onChange={(e) => setFormData({ ...formData, company: e.target.value })}
          />
          <label>
            <input
              type="checkbox"
              className="sc-checkbox"
              checked={formData.consent}
              onChange={(e) => setFormData({ ...formData, consent: e.target.checked })}
            />
            I understand by submitting this form you may have permission to contact me<span>*</span>
          </label>
          {errors.step3 && <p className="error-message">All fields are required</p>}

          <div className="sc-navigation-btns">
            <button onClick={prevStep} className="sv-prev-btn">Previous</button>
            <button
              className="sc-continue-btn"
              onClick={submitCalculator}
              disabled={!step3IsValid}
            >
              Calculate Savings
            </button>
          </div>
        </div>
      )}

      {/* STEP 4: Results */}
      {step === 4 && (
        <div className="sv-results">
          <div className="savings-boxes">
            <div className="savings-box left">
              <img src={energyimage} alt="Energy Saving" className="savings-image" />
              <p>
                <strong>Estimated Annual Energy Saving</strong>
                <span>{savedKwh !== null && savedKwh !== undefined ? savedKwh.toFixed(2) : "0.00"} kWh</span>
              </p>
            </div>
            <div className="savings-box right">
              <img src={costimage} alt="Cost Saving" className="savings-image" />
              <p>
                <strong>Estimated Annual Electricity Cost Saving</strong>
                <span>{estiSavings !== null && estiSavings !== undefined ? estiSavings.toFixed(2) : "0.00"} RM</span>
              </p>
            </div>
          </div>

          <div className="sv-user-info-container sv-unified">
            <div className="sv-section sv-info-section">
              <h2>Thank you for your inquiry.</h2>
              <h2 className="sv-subtext"> The information you have provided is as follows:</h2>
              <div className="sv-info-row">
                <label>Country:</label>
                <p>{formData.location}</p>
              </div>
              <div className="sv-info-row">
                <label>Building/Company Name:</label>
                <p>{formData.company}</p>
              </div>
              <div className="sv-info-row">
                <label>Name:</label>
                <p>{formData.name}</p>
              </div>
              <div className="sv-info-row">
                <label>Email:</label>
                <p>{formData.email}</p>
              </div>
            </div>

            <div className="sv-section sv-message-section">
              <p>
                We&apos;ll be in touch shortly to explain how this estimate is calculated 
                and to better understand your requirements.
              </p>
              <p>
                We look forward to helping you save energy, reduce costs, 
                and support your sustainability journey.
              </p>
              <div className="sv-buttons-container">
                <button
                  className="sv-restart-btn"
                  onClick={() => {
                    // Reset the calculator state and go back to Step 1.
                    setStep(1);
                    // Reset all states
                    setChillerType("");
                    setOtherChillerBrand("");
                    setChillerRT("");
                    setChillerYear("");
                    setOperatingUnit("");
                    setBuildingType("");
                    setChillerDesignCapacity("");
                    setOperatingDays("");
                    setNumberOfChillers("");
                    setPeakHours("");
                    setOffpeakHours("");
                    setFla("");
                    setTariff("");
                    setestiSavings(null);
                    setSavedKwh(null);
                    setFormData({
                      name: '',
                      email: '',
                      company: '',
                      consent: false,
                      location: ''
                    });
                    setChillers([
                      {
                        chillerType: "",
                        otherChillerBrand: "",
                        chillerRT: "",
                        chillerYear: "",
                        operatingUnit: "",
                        operatingDays: "",
                        chillerDesignCapacity: "",
                        numberOfChillers: "",
                        fla: "",
                        peakHours: "",
                        offpeakHours: ""
                      }
                    ]);
                  }}
                >
                  Calculate for another building
                </button>
                <button
                  className="sv-contactus-btn"
                  onClick={() => {
                    window.location.href = "https://squarecloudasia.com/contactUs";
                  }}
                >
                  Contact Us
                </button>
              </div>
            </div> 
          </div>
        </div>
      )}
    </div>
  );
}

export default ChillerSavingsCalculator;
